/**
 * @deprecated
 */

import { type SnakeToCamelCaseNested } from "./utility-types/notation-utility.types";

export type StickSingleFlavorResponse = {
  sku: string;
  flavour: number | string;
  flavour_label: string;
  swatch_data: string | null;
};

export type StickMixAndMatchResponse = {
  sku: string;
  flavour?: null;
  flavour_label?: null;
  swatch_data?: null;
};

export type StickResponse = StickSingleFlavorResponse | StickMixAndMatchResponse;

export type SticksPeriodResponse = {
  onetime: StickSingleFlavorResponse[];
  subscription: StickSingleFlavorResponse[];
};

export type SticksMixAndMatchPeriodResponse = {
  onetime: StickMixAndMatchResponse[];
  subscription: StickMixAndMatchResponse[];
};

export type GetSticksMatrixResponse = {
  getSticksMatrix: {
    single_packs: SticksPeriodResponse;
    cartons: SticksPeriodResponse;
    mix_n_match: SticksMixAndMatchPeriodResponse;
  };
};

export type SticksMatrix = SnakeToCamelCaseNested<GetSticksMatrixResponse["getSticksMatrix"]>;
export type SticksPeriod = SnakeToCamelCaseNested<SticksPeriodResponse>;
export type SticksMixAndMatchPeriod = SnakeToCamelCaseNested<SticksMixAndMatchPeriodResponse>;
export type StickSingleFlavor = SnakeToCamelCaseNested<StickSingleFlavorResponse>;
export type StickMixAndMatch = SnakeToCamelCaseNested<StickMixAndMatchResponse>;
export type Stick = StickSingleFlavor | StickMixAndMatch;
